'use strict';

/**
 * Render iframe for fraud protection
 */
function paymorrowInit() {
    if (document.getElementById('paymorrow-iframe')) {
        return;
    }
    try {
        var iframeConfig = $('.paymorrow-config');
        var deviceUrl = iframeConfig.data('device-url');
        var gateUrl = iframeConfig.data('iframe-url');

        $.ajax({
            url: deviceUrl,
            success: function (data) { // eslint-disable-line consistent-return
                if (!data) {
                    return false;
                }
                if (gateUrl + data.deviceid) {
                    var iframe = document.createElement('iframe');
                    iframe.id = 'paymorrow-iframe';
                    iframe.style = 'width: 1px; height: 1px; border: 0; overflow: hidden; display:none !important; visibility:hidden !important; z-index:-9999 !important;';
                    iframe.src = encodeURI(gateUrl + data.deviceid);
                    document.body.appendChild(iframe);
                    iframeConfig.remove();
                }
            }
        });
    } catch (ex) {
        console.warn('Payment operator iframe failed!'); // eslint-disable-line no-console
    }
}

module.exports = {
    paymorrowInit: paymorrowInit
};
